import { tableSortLabelClasses } from '@mui/material/TableSortLabel';
import typography from '../theme/typography';
import colors from '../theme/colors';

const styleOverrides = {
  root: {
    '&:hover': {
      textDecoration: 'underline',
    },
    [`&.${tableSortLabelClasses.active}`]: {
      color: colors.transparentGray['600'],
    },
  },
  icon: {
    marginLeft: 8,
    marginRight: 8,
    fontSize: typography.fontSize,
  },
};

export default styleOverrides;
